import React, { useEffect } from "react";
import {
    clearTopNavbar,
    setTopNavbar,
} from "../../Reducers/actions/navbarActions";
import { getPaginatedPayouts } from "../../Reducers/actions/accountActions";
import { useDispatch, useSelector } from "react-redux";
import { TransactionSummaryRowSkeleton } from "../../components/Skeletons/FinanceListSkeletons";
import TransactionSummary from "./TransactionSummary";

function TransactionSummaryList() {
    const dispatch = useDispatch();

    const { payoutsLoading, payouts } = useSelector((state) => ({
        payouts: state?.account?.payouts,
        payoutsLoading: state?.account?.payoutsLoading,
    }));

    useEffect(() => {
        dispatch(
            setTopNavbar({
                title: "Transactions",
                showBackArrow: true,
            })
        );
        dispatch(getPaginatedPayouts(100));

        return () => {
            dispatch(clearTopNavbar());
        };
    }, []);

    if (payoutsLoading) {
        return (
            <div className="py-24 px-16 mt-48" role="status" aria-label="Loading transactions">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                    <TransactionSummaryRowSkeleton key={i} />
                ))}
            </div>
        );
    }

    return (
        <div className="py-24 px-16 mt-48">
            {payouts?.data?.map((transaction) => (
                <TransactionSummary transaction={transaction} />
            ))}
        </div>
    );
}

export default TransactionSummaryList;
